import React, {FC} from "react";
import {formatValueAsDateAndTime} from "../../helpers/utils/DateUtils";
import {truncateText} from "../../helpers/utils/TextUtils";

interface props {
    data: any
}

const AuditableInfo: FC<props> = ({data}) => {
    return (
        <>
            <div className="max-w-[210px] w-full text-left text-text-2 text-sm">
                <div
                    title={`Modified by ${data?.modifiedBy} on ${formatValueAsDateAndTime(data?.modifiedDate)}`}
                >
                    <span>Created by: </span>
                    <span className="italic">
                        {data?.createdBy}
                    </span>
                </div>
                <div>
                    <span>Created on: </span>
                    <span className="italic">
                        {formatValueAsDateAndTime(data?.creationDate)}
                    </span>
                </div>

                {data?.dateDelivered && (
                    <div className="mt-1">
                        <div title={data?.deliveredTo?.join(",")}>
                            Delivered to:{" "}
                            <span className="italic">
                                {truncateText(data?.deliveredTo?.join(",") || "-", 10)}
                            </span>
                        </div>
                        <div>
                            Delivered on:
                            <span className="italic"> {formatValueAsDateAndTime(data?.dateDelivered)}</span>
                        </div>
                    </div>
                )}

                {data?.count && (
                    <div className="mt-1">

                        <div>
                            Occurrences:
                            <span className="italic"> {data?.count}</span>
                        </div>
                    </div>
                )}
            </div>


        </>
    )
}

export default AuditableInfo;